import { h } from 'hyperapp'

const Footer = () => (
  <footer class="text-center font-fixedsys text-purple max-h-40 sm:max-h-48 flex-1 flex justify-end flex-col">
    <span class="my-4">
      made with <span class="text-crimson">❤</span> by{' '}
      <a class="text-crimson" href="https://hayk.earth">
        Հայկ
      </a>
    </span>
  </footer>
)

export default Footer
